import React, { useState, useEffect } from 'react';

import SeminarsAll from "./SeminarsAll";
import ConferencesAll from "./ConferencesAll";
import { useTranslation } from "../../context/TranslationContext"; 

const Seminars = () => {
  const [selectedSection, setSelectedSection] = useState("allSeminars");

  const showSeminars = () => setSelectedSection("allSeminars");
  const showConferences = () => setSelectedSection("allConferences");

  const { translations , language} = useTranslation(); 
  const isArabic = language === "ar";



  return (
    <>
      <div className={`flex ${isArabic ? 'flex-col md:flex-row' : 'flex-col-reverse md:flex-row-reverse '} pt-16 w-full`}>

        <div className="border-t"></div>


        <div
          className=" flex-1"
          style={{
            fontFamily: "Tajwal, sans-serif",
            direction: isArabic ? "rtl" : "ltr",
            textAlign: isArabic ? "right" : "left",
          }}
        >
          <h2 className="text-xl font-bold mb-1">{translations.seminarsAndConferences}</h2>
          <h4 className="text-l font-bold text-gray-500">
          {translations.continueWatching}
          </h4>

          <div className="flex flex-wrap justify-center md:justify-start mt-4 gap-2">
            <button
              className={`py-2 px-4 rounded mr-2 ml-4 ${
                selectedSection === "allSeminars"
                  ? "bg-secondary-green text-white"
                  : "bg-gray-400 text-white hover:bg-secondary-green"
              }`}
              onClick={showSeminars}
            >
             {translations.viewAllSeminars}
            </button>

            <button
              className={`py-2 px-4 rounded ${
                selectedSection === "allConferences"
                  ? "bg-secondary-green text-white"
                  : "bg-gray-400 text-white hover:bg-secondary-green"
              }`}
              onClick={showConferences}
            >
             {translations.viewAllConferences}
            </button>
          </div>

          <div className="mt-4">
            {selectedSection === "allSeminars" && <SeminarsAll />}
            {selectedSection === "allConferences" && <ConferencesAll />}
          </div>
        </div>

      </div>
    </>
  );
};

export default Seminars;